var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRectangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 21,
    viewBox: "0 0 33 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_626_5527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6868 15.639C10.4171 15.639 10.1568 15.5404 9.95472 15.3618L2.91315 9.13655C2.42392 8.70403 2.41432 7.9439 2.89248 7.49917L9.95008 0.934985C10.1546 0.744774 10.4235 0.639039 10.7028 0.639039L28.8947 0.639038C29.5052 0.639038 30 1.13388 30 1.7443L30 14.5338C30 15.1442 29.5052 15.639 28.8947 15.639L10.6868 15.639Z",
    fill: "#4886FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6868 15.3627C10.4845 15.3627 10.2893 15.2888 10.1377 15.1548L3.09617 8.92953C2.72924 8.60514 2.72204 8.03505 3.08066 7.7015L10.1383 1.13731C10.2916 0.994655 10.4933 0.915354 10.7028 0.915354L28.8947 0.915354C29.3526 0.915354 29.7237 1.28649 29.7237 1.7443L29.7237 14.5338C29.7237 14.9916 29.3526 15.3627 28.8947 15.3627L10.6868 15.3627Z",
    stroke: "#96B9FF",
    strokeWidth: 0.552632
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_626_5527",
    x: 0.329513,
    y: 0.639038,
    width: 31.881,
    height: 19.4211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.21053
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.10526
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_626_5527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_626_5527",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle);
export default __webpack_public_path__ + "static/media/rectangle.8b01f67162409b105cf98a2877ab119c.svg";
export { ForwardRef as ReactComponent };